import moment from 'moment'
import * as d3 from 'd3'
export default {
  methods: {

    gmx_datePicker(selection, props) {

      picker_Shadow(selection)

      let today = moment(new Date()).format('YYYY-MM-DD')
      let days = this.gmx_calendarDays(props.date)

      let picker = selection
      .append('g')
      .attr('id', `DATE_PICKER_CANVAS`)
      .attr('transform', `translate(${props.x}, ${props.y})`).attr('opacity', 1)

      picker
      .append('rect')
      .attr('rx', 5).attr('ry', 5).attr('width', 220).attr('height', days.length==42 ? 250 : 225)
      .attr('fill', '#fff').attr('stroke', '#000')
      .attr('filter', 'url(#PickerShadow)').attr('opacity', .2)

      picker
      .append('rect')
      .attr('rx', 5).attr('ry', 5).attr('width', 220).attr('height', days.length==42 ? 250 : 225)
      .attr('fill', '#fff').attr('stroke', '#bcbcbc').attr('storke-width', .5)

      // Close Icon
      picker
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Close.svg`)
      .attr('x', 202).attr('y', 4).attr('width', 13).attr('opacity', .5).attr('cursor', 'pointer')
      .on('mouseover', function() {d3.select(this).transition().duration(75).attr('opacity', 1)})
      .on('mouseout', function() {d3.select(this).transition().duration(250).attr('opacity', .4)})
      .on('click', () => {
        d3.select(`#DATE_PICKER_CANVAS`).transition().duration(500).attr('opacity', 0)
        setTimeout(()=> { d3.select(`#DATE_PICKER_CANVAS`).remove()}, 500)
      })
      
      // Header
      let yearMonth = picker
      .append('g')
      .attr('id', `YEAR_MONTH`)
      .attr('transform', `translate(0, 42)`)

      yearMonth
      .append('text')
      .attr('id', `PICKER_YEAR`)
      .attr('font-size', 16).attr('fill', '#000')
      .text(moment(props.date).format("YYYY"))

      yearMonth
      .append('text')
      .attr('id', `PICKER_MONTH`)
      .attr('x', this.getNode(`#PICKER_YEAR`)+5).attr('font-size', 12).attr('fill', '#333')
      .text(moment(props.date).format("MMMM"))

      d3.select(`#YEAR_MONTH`).attr('transform', `translate(${110 - (this.getNode(`#YEAR_MONTH`)/2)}, 42)`)

      picker
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Back.svg`)
      .attr('x', 10).attr('y', 25).attr('width', 22).attr('opacity', .5)
      .call(this.gmx_calendarMonth, selection, props, 'back')

      picker
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Next.svg`)
      .attr('x', 190).attr('y', 25).attr('width', 22).attr('opacity', .5)
      .call(this.gmx_calendarMonth, selection, props, 'next')
      

      // Draw Weekdays
      let weekdays = picker
      .append('g')
      .attr('transform', `translate(${0}, ${70})`)

      for (let i = 0; i <= 6; i++) {
        let weeks = moment().day(i).format('ddd')
        weekdays
        .append('text')
        .attr('x', i*30+20).attr('font-size', 12).attr('text-anchor', 'middle')
        .attr('fill', weeks=='Sun' ? '#EC407A' : weeks=='Sat' ? '#44A9DF' : '#000')
        .text(weeks)
      }

      // Draw Date
      let calendar = picker
      .append('g')
      .attr('transform', `translate(${0}, ${100})`)

      let x_ = 20, y_ = 0, cnt = 1
      days.forEach((d,i)=> {

        let calendarDay = calendar
        .append('g')
        .attr('transform', `translate(${x_}, ${y_})`).attr('cursor', 'pointer')
        .on('mouseover', ()=> {
          d3.select(`#PICKER_CIRCLE_${i}`).transition().duration(50).attr('r', 12).attr('opacity', 1)
          d3.select(`#PICKER_DATE_${i}`).transition().duration(50).attr('transform', `translate(0,.5)`).attr('fill', '#000').attr('font-size', 14)
        })
        .on('mouseout', ()=> {
          d3.select(`#PICKER_CIRCLE_${i}`).transition().duration(500).attr('r', 1).attr('opacity', 0)
          d3.select(`#PICKER_DATE_${i}`).transition().duration(300).attr('transform', `translate(0,0)`).attr('fill', d.month=='this' ? '#333' : '#bcbcbc').attr('font-size', 12)
        })
        .on('click', ()=> {
          d3.select(`${props.id}`).text(d.date)
          d3.select(`#DATE_PICKER_CANVAS`).transition().duration(500).attr('opacity', 0)
          setTimeout(()=> { d3.select(`#DATE_PICKER_CANVAS`).remove()}, 500)
        })

        calendarDay
        .append('circle')
        .attr('cy',-4).attr('r', 12).attr('font-size', 12).attr('fill', '#fff').attr('opacity', 0)

        if(d.date == today) {
          calendarDay
          .append('circle')
          .attr('cy',-4).attr('r', 12).attr('fill', '#fff').attr('stroke', '#EC407A').attr('stroke-width', .5)
        }

        if(d.date == d3.select(props.id).text()) {
          calendarDay
          .append('circle')
          .attr('cy',-4).attr('r', 12).attr('fill', '#B4E3FA').attr('fill-opacity', .2).attr('stroke', '#83D2F5').attr('stroke-width', 1)
        }

        calendarDay
        .append('circle')
        .attr('id', `PICKER_CIRCLE_${i}`)
        .attr('cy',-4).attr('r', 1).attr('fill', '#B4E3FA').attr('fill-opacity', .2).attr('stroke', '#83D2F5').attr('stroke-width', 1).attr('opacity', 0)

        calendarDay
        .append('text')
        .attr('id', `PICKER_DATE_${i}`)
        .attr('transform', `translate(0,0)`)
        .attr('font-size', 12).attr('text-anchor', 'middle')
        .attr('fill', d.month=='this' ? '#333' : '#bcbcbc')
        .text(d.days)

        if((cnt%7).toFixed(1) == 0) {
          x_ = 20
          y_ += 27
        } else x_ += 30
        cnt ++
      })

      function picker_Shadow() {
        let PickerShadow = selection.append('defs')
        .append('filter').attr('id', 'PickerShadow')

        PickerShadow.append('feGaussianBlur') .attr('in', 'SourceAlpha').attr('stdDeviation', 2).attr('result', 'blur')
        PickerShadow.append('feOffset').attr('in', 'blur').attr('dx', .3).attr('dy', .3).attr('result', 'offsetBlur')

        let feMerge2 = PickerShadow.append('feMerge')
        feMerge2.append('feMergeNode').attr('in', 'offsetBlur')
        feMerge2.append('feMergeNode').attr('in', 'SourceGraphic')
      }
    },


    gmx_calendarDays(date) {
      let thisDate = moment(date)
      let previousMonth = moment(date).subtract(1, 'month')
      let previousMonthDays = previousMonth.daysInMonth()
      let nextMonth = moment(date).add(1, 'month')
      let firstDayDate = moment(date).startOf('month')

      let days = []

      for (let i = firstDayDate.day(); i > 0; i--) {
        previousMonth.date(previousMonthDays - i + 1)
        days.push({ month: 'pre', days: previousMonthDays-i+1, date: moment(previousMonth).format('YYYY-MM-DD'),
        })
      }

      let daysInMonth = moment(date).daysInMonth()
      for (let i = 1; i <= daysInMonth; i++) {
        days.push({ month: 'this', days: i, date: moment(thisDate.date(i)).format('YYYY-MM-DD'), })
      }

      let daysCnt = days.length
      let baseNum = (daysCnt > 35) ? 42 : 35
      for (let i = 1; i <= (baseNum - daysCnt); i++) {
        nextMonth.date(i)
        days.push({month: 'next', days: i, date: moment(nextMonth).format('YYYY-MM-DD'),})
      }
      return days
    },


    gmx_calendarMonth(selection, mode, props, str) {
      
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', 1)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', .4)
      })
      .on('click', () => {
        d3.select(`#DATE_PICKER_CANVAS`).remove()

        if(str == 'back') props.date = moment(props.date).subtract(1, 'month')
        if(str == 'next') props.date = moment(props.date).add(1, 'month')
        
        this.gmx_datePicker(mode, props)
      })
    },

  } 
}